import React from "react";

import HeaderOne from "../../components/UI/HeaderOneMain";
// import FooterOne from "../components/UI/FooterOneMain";
import BottomFooter from "../../components/UI/BottomFooterMain";
// import Breadcrumb from "../../components/UI/BreadcrumbMain";
import FooterOneMain from "../../components/UI/FooterOneMain";
import ShippingOne from "../../components/UI/ShippingOneMain";
import ScrollToTop from "react-scroll-to-top";
import ColorInit from "../../helper/ColorInit";
import Login from "../../components/UI/Login";
import Preloader from "../../helper/Preloader";

const LoginPage = () => {
  return (
    <>
      {/* ColorInit */}
      <ColorInit color={false} />

      {/* ScrollToTop */}
      <ScrollToTop smooth color="#299E60" />

      {/* Preloader */}
      <Preloader />

      {/* HeaderTwo */}
      <HeaderOne category={false} />

      {/* Breadcrumb */}
      {/* <Breadcrumb title={"Account"} /> */}

      {/* Account */}
      <Login />

      {/* ShippingOne */}
      <ShippingOne />

      {/* FooterTwo */}
      <FooterOneMain />

      {/* BottomFooter */}
      <BottomFooter />
    </>
  );
};

export default LoginPage;
